
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 23.25a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3zm0-3a.75.75 0 01-.75-.75v-1.157a6.708 6.708 0 01-4.5-6.389C5.263 8.246 8.291 5.229 12 5.229a6.718 6.718 0 014.79 1.994 6.708 6.708 0 011.96 4.78 6.697 6.697 0 01-4.5 6.341V19.5a.75.75 0 01-.75.75h-3zm2.25-1.5v-.962a.75.75 0 01.564-.727 5.236 5.236 0 003.936-5.063 5.217 5.217 0 00-1.524-3.719 5.215 5.215 0 00-3.707-1.551l-.021-.375v.375a5.258 5.258 0 00-5.247 5.231 5.245 5.245 0 003.937 5.102.75.75 0 01.562.726v.962h1.5zm-.75-15a.75.75 0 01-.75-.75V1.5a.75.75 0 011.5 0V3a.75.75 0 01-.75.75zm9 7.5a.75.75 0 010-1.5h1.5a.75.75 0 010 1.5H21zm-19.5 1.5a.75.75 0 010-1.5H3a.75.75 0 010 1.5H1.5zm17.925 6.675a.743.743 0 01-.53-.22l-1.061-1.061a.752.752 0 01.53-1.281c.2 0 .389.078.53.22l1.061 1.061a.752.752 0 01-.53 1.281zM5.636 5.636a.743.743 0 01-.53-.22L4.045 4.355c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53c.141-.142.33-.22.53-.22s.389.078.53.22l1.061 1.061c.142.141.22.33.22.53s-.078.389-.22.53a.743.743 0 01-.53.22zm12.728 0a.743.743 0 01-.53-.22c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53l1.061-1.061a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-1.061 1.061a.743.743 0 01-.53.22zM4.575 19.425a.752.752 0 01-.53-1.281l1.061-1.061a.744.744 0 011.06 0 .752.752 0 010 1.061l-1.061 1.061a.743.743 0 01-.53.22z"}})])
          )
        }
      }
    